import React from "react";
import { HStack, Spacer, Tag } from "@chakra-ui/react";
import { format, parseISO } from "date-fns";
import { DigitalSignature, Form } from "components";
import { useCurrentCase, useOrganizationSettings } from "duck";
import {
  getDisclaimer,
  getValidationSchema,
  useUpdateDisclaimer
} from "./duck";

const Signature: React.FC = () => {
  const defaultValues = useCurrentCase(medicalCase =>
    getDisclaimer(medicalCase.data)
  );
  const { createdAt, procedureDate } = useCurrentCase(medicalCase => ({
    createdAt: medicalCase.data.client.disclaimer.createdAt,
    procedureDate: medicalCase.data.client.patient.procedureDate
  }));
  const { dateFormat } = useOrganizationSettings();
  const update = useUpdateDisclaimer();

  return (
    <Form
      validationSchema={getValidationSchema()}
      defaultValues={defaultValues}
    >
      <Form.Watcher onChange={update as any} defaultValues={defaultValues} />
      <HStack mb={6}>
        <Spacer />
        <Tag color="gray.600" bgColor="gray.200">
          {format(
            parseISO(defaultValues.signature ? createdAt : procedureDate),
            dateFormat
          )}
        </Tag>
      </HStack>
      <DigitalSignature name="signature" label="Client’s Signature" />
    </Form>
  );
};

export default Signature;
